import type { IconProps } from "../types";

export const IconUsers = ({width, height, className}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 16"
    fill="currentColor"
    
  >
    <path d="M14 12.5a2.5 2.5 0 0 0-2.5-2.5h-7A2.5 2.5 0 0 0 2 12.5V15h12v-2.5ZM12 6h2a2 2 0 0 1 2 2v3h-1.337A3.501 3.501 0 0 0 11.5 9h-.855A3.99 3.99 0 0 0 12 6ZM1.337 11H0V8a2 2 0 0 1 2-2h2a3.99 3.99 0 0 0 1.355 3H4.5a3.5 3.5 0 0 0-3.163 2ZM8 3a3.001 3.001 0 0 1 0 6 3.001 3.001 0 0 1 0-6ZM4.127 4.996a2 2 0 1 1 1.825-2.432 4.014 4.014 0 0 0-1.825 2.432Zm5.921-2.432a2 2 0 1 1 1.825 2.432 4.014 4.014 0 0 0-1.825-2.432Z" />
  </svg>
)

